import React from 'react';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';
import { Card } from 'react-bootstrap';

const SettingsToggle: React.FC = () => {
  const { toggleSettingsPanel } = useSettingsPanelContext();

  return (
    <Card className="setting-toggle" onClick={toggleSettingsPanel}>
      <Card.Body className="d-flex align-items-center px-2 py-1">
        <div className="position-relative rounded-start" style={{ height: 30 }}>
          <small className="text-uppercase text-body-tertiary fw-semibold pe-3 ps-3 fs-10 rounded-end">
            Customize
          </small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SettingsToggle;
